const THEME = {
    BLACK: 'BLACK',
    WHITE: 'WHITE',
    CUSTOMER: 'CUSTOMER'
};
const THEME_LIST = [
    { value: THEME.BLACK, label: '黑肤'},
    { value: THEME.WHITE, label: '白肤'},
    { value: THEME.CUSTOMER, label: '自定义'},
];

const MARKET = {
    'HK': '1',
    'US': '2',
    'CN': '3',
    'SG': '4',
    'AU': '5',
    'CA': '6',
    'JP': '7',
};

const MARKET_ARR = [
    'HK',
    'US',
    'AU',
    'SG',
    'SH',
    'SZ'
]

const UP_DOWN_COLOR = {
    greenUp: 'greenUp',
    redUp: 'redUp',
};

const STOCK_NAME_FONT_SIZE = {
    WEB: 8,
    H5: 13
};
const STOCK_PRICE_FONT_SIZE = {
    WEB: 8,
    H5: 14
};
const STOCK_TREND_FONT_SIZE = {
    WEB: 6,
    H5: 12
};

const STOCK_NAME_FONT_FAMILY = 'brMedium';
const STOCK_PRICE_FONT_FAMILY = 'brMedium';
const STOCK_TREND_FONT_FAMILY = 'brRegular';


const DEFAULT_LANG = 'tcName'; // 默认语言

const LANG_CODE_2_LANGUAGE = {
    scName: '简体中文',
    tcName: '繁体中文',
    name: '英文'
};

export default {
    THEME,
    THEME_LIST,
    MARKET,
    UP_DOWN_COLOR,
    STOCK_NAME_FONT_SIZE,
    STOCK_PRICE_FONT_SIZE,
    STOCK_TREND_FONT_SIZE,
    STOCK_NAME_FONT_FAMILY,
    STOCK_PRICE_FONT_FAMILY,
    STOCK_TREND_FONT_FAMILY,
    DEFAULT_LANG,
    LANG_CODE_2_LANGUAGE,
    MARKET_ARR
}
